import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">内容分类</h2>
        <p className="text-sm text-foreground-500 mt-2">选择您感兴趣的内容类别，获取专业的安全资讯</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => {
          const count = articles.filter((a) => a.categorySlug === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 rounded-lg hover:bg-accent-50 transition-all cursor-pointer border border-background-200/70 hover:border-accent-200"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg group-hover:bg-accent-500 group-hover:text-background-50 transition-all text-xl md:text-2xl">
                <i className={cat.icon}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500">{count} 篇文章</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}